function testimonialsSlider() {
  [...document.querySelectorAll('.testimonials-grid')]?.forEach( slider => {
    new Splide( slider, {
      type: 'loop',
      speed: 1000,
      fixedWidth: '20.4375rem',
      perPage: 1,
      perMove: 1,
      focus: 'center',
      gap: '1.5rem',
      autoHeight: true,
      lazyload: 'sequential',
      mediaQuery: 'min',
      breakpoints: {
        992: {
          destroy: true,
        },
      }
    } ).mount();
  })
}

document.addEventListener( 'DOMContentLoaded', function() {
  testimonialsSlider();
});